import {
  GET_COMPARED_BUYERS,
  GET_COMPARED_BUYERS_ERROR,
  GET_COMPARED_BUYERS_SUCCESS
} from './CompareBuyersSection.actions'

const compareBuyersSectionState = {
  error: null,
  firstBuyers: [],
  loading: false,
  secondBuyers: []
}

/**
 * The compare buyers section's reducer.
 */
const compareBuyersSectionReducer = (state = compareBuyersSectionState, { payload, type }) => {
  switch (type) {
    case GET_COMPARED_BUYERS: {
      return { ...state, loading: true }
    }
    case GET_COMPARED_BUYERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_COMPARED_BUYERS_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default compareBuyersSectionReducer
